import { createSlice } from "@reduxjs/toolkit";

const initialState = {
	tableData: [{}],
};

export const TravelAdvanceSlice = createSlice({
	name: "travelAdvance",
	initialState,
	reducers: {
		setTableData: (state, action) => {
			state.tableData = action.payload;
		},
	},
});

// Action creators are generated for each case reducer function
export const { setTableData } = TravelAdvanceSlice.actions;

export default TravelAdvanceSlice.reducer;
